import { useCallback, useEffect, useRef, useState } from "react";

export function useDebouncedValue<T>(value: T, setValue: (val: T) => void, delay: number) {
  const timeoutRef = useRef(0);
  const [innerValue, setInnerValue] = useState(value);

  useEffect(
    () => {
      if (value !== innerValue) {
        setInnerValue(value);
      }
    },
    // We only want to synchronize when value changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value]
  );

  const setValueCb = useCallback(
    (newVal: T) => {
      setInnerValue(newVal);

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = 0;
      }

      timeoutRef.current = window.setTimeout(() => {
        timeoutRef.current = 0;
        setValue(newVal);
      }, delay);
    },
    [setValue, delay]
  );

  return [innerValue, setValueCb] as [T, (val: T) => void];
}
